import { Collapse, CollapseProps, ConfigProvider, Spin, message } from 'antd'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import '../../styles/antd/collapseStyle.css'
import { TabEmptyText } from '../PatientsView/PatientsViewStyle'
import { ReactComponent as WarningIconFilled } from '../../assets/Icons_Warning Fill.svg'
import { ReactComponent as CriticalconFilled } from '../../assets/Icons_ Critical Fill.svg'
import { ReactComponent as UrgentIconFilled } from '../../assets/Icons_Urgent Fill.svg'
import {
  AlertCollapseContainer,
  AlertCollapseContentContainer,
  AlertCollapseEnd,
  AlertCollapseTitle,
  StyledAlertIcon,
  alertPanelStyle,
} from './AlertsCollapseStyle'
import { useGetPatientAlertsQuery } from '../../state/alerts/api'
import { displayMessage } from '../../helpers/Message'

type AlertTabProps = {
  size?: 'small'
}

function AlertsCollapse({ size }: AlertTabProps) {
  const {
    data: alertDataRespone,
    isLoading,
    error,
  } = useGetPatientAlertsQuery({})
  const alertsData = alertDataRespone?.alerts
  const alertsLength = alertsData?.length
  if (!alertsData)
    return (
      <AlertCollapseContainer>
        <Spin size='large' />
      </AlertCollapseContainer>
    )
  if (!alertsLength) return <TabEmptyText>No Alerts Data</TabEmptyText>
  const alertTypeIcons = {
    Urgent: UrgentIconFilled,
    Warning: WarningIconFilled,
    Critical: CriticalconFilled,
  }

  const AlertIcon = ({
    alertType,
  }: {
    alertType: 'Warning' | 'Critical' | 'Urgent'
  }) => {
    return (
      <StyledAlertIcon
        iconsize={size}
        component={alertTypeIcons[alertType!]}
        type={alertType}
      />
    )
  }

  const divider = size === 'small' ? <br /> : '-'

  const alertItems: CollapseProps['items'] = alertsData.map((alert) => {
    return {
      key: alert.alertId,
      label: (
        <AlertCollapseTitle size={size}>
          <span>
            <AlertIcon alertType={alert.type} />
            <span>
              {`${alert.type} Individual Alert`} {divider} {alert.status}
            </span>
          </span>
          <span style={{ textAlign: 'end' }}>
            <AlertCollapseEnd>
              {alert.patient.title} {alert.patient.firstName}{' '}
              {alert.patient.lastName}{' '}
              <span>
                {divider} {alert.createTimestamp}
              </span>{' '}
            </AlertCollapseEnd>
          </span>
        </AlertCollapseTitle>
      ),
      children: (
        <AlertCollapseContentContainer size={size}>
          {alert.message}
        </AlertCollapseContentContainer>
      ),
      className: alert.type,
      style: alertPanelStyle(alert.type),
    }
  })

  return (
    <ConfigProvider
      theme={{
        components: {
          Collapse: {
            headerBg: 'transparent',
          },
        },
      }}
    >
      <AlertCollapseContainer>
        <Collapse
          size={size}
          accordion
          bordered={false}
          className='alertAccordion'
          items={alertItems}
        />
      </AlertCollapseContainer>
    </ConfigProvider>
  )
}

export default AlertsCollapse
